export const DEFAULT_PRIVATE_WORKSPACE_PATH = '/dashboard';

export const currentRouteTarget = (location: {
  pathname: string;
  search?: string;
  hash?: string;
}) => `${location.pathname}${location.search ?? ''}${location.hash ?? ''}`;

export const safeInternalReturnTo = (value?: string | null): string => {
  if (!value) return '';
  const trimmed = value.trim();
  if (!trimmed.startsWith('/') || trimmed.startsWith('//')) return '';
  for (let index = 0; index < trimmed.length; index += 1) {
    const code = trimmed.charCodeAt(index);
    if (code <= 31 || code === 127) return '';
  }
  return trimmed;
};

export const privateAccessPath = (
  returnTo?: string | null,
  intent = 'unlock-private-intelligence'
) => {
  const params = new URLSearchParams();
  const safeReturnTo = safeInternalReturnTo(returnTo);
  if (safeReturnTo) {
    params.set('returnTo', safeReturnTo);
  }
  params.set('intent', intent);
  return `/private-access?${params.toString()}`;
};

export const buildTokenDossierRef = (token: {
  chain_id?: string | null;
  contract_address?: string | null;
  symbol?: string | null;
  canonical_symbol?: string | null;
  rank_id?: string | null;
  discovery_id?: string | null;
}) => {
  const chain = token.chain_id?.trim() || 'market';
  const identity =
    token.contract_address?.trim() ||
    token.symbol?.trim() ||
    token.canonical_symbol?.trim() ||
    token.rank_id?.trim() ||
    token.discovery_id?.trim() ||
    'unknown';
  return `${chain}:${identity}`;
};

export const tokenDossierPath = (tokenRef: string) => `/tokens/${encodeURIComponent(tokenRef)}`;

export const privateTokenDossierPath = (tokenRef: string) =>
  `/dossiers/${encodeURIComponent(tokenRef)}`;
